import { ReactComponent as Pie } from "../../../assets/graphIconsSvg/pie.svg";
import { ReactComponent as Bar } from "../../../assets/graphIconsSvg/bar.svg";
import { ReactComponent as Line } from "../../../assets/graphIconsSvg/line.svg";
import { ReactComponent as LineBar } from "../../../assets/graphIconsSvg/lineBar.svg";
import { ReactComponent as HorizBar } from "../../../assets/graphIconsSvg/horizontalBar.svg";
import { ReactComponent as Table } from "../../../assets/graphIconsSvg/table.svg";
import { ReactComponent as Radial } from "../../../assets/graphIconsSvg/radial.svg";
import { ReactComponent as Heatmap } from "../../../assets/graphIconsSvg/heatmap.svg";
import { ReactComponent as CircularProgress } from "../../../assets/graphIconsSvg/circularProgess.svg";
import { ReactComponent as LinearProgress } from "../../../assets/graphIconsSvg/linearProgress.svg";
import { ReactComponent as Sankey } from "../../../assets/graphIconsSvg/sankey.svg";
import { ReactComponent as Linear } from "../../../assets/graphIconsSvg/linear.svg";
import { ReactComponent as Html } from "../../../assets/graphIconsSvg/html.svg";
import { ReactComponent as Map } from "../../../assets/graphIconsSvg/map.svg";
import { ReactComponent as Repeat } from "../../../assets/graphIconsSvg/repeat_2.svg";

import { Box, IconButton, Typography, Grid, useTheme } from "@mui/material";
import React from "react";

const ICONS = [
  { label: "Pie", value: "pie", Icon: Pie },
  { label: "Bar", value: "bar", Icon: Bar },
  { label: "Line", value: "line", Icon: Line },
  { label: "LineBar", value: "lineBar", Icon: LineBar },
  { label: "Horizontal Bar", value: "barHorizontal", Icon: HorizBar },
  { label: "Table", value: "datagrid", Icon: Table },
  { label: "Radial", value: "radial", Icon: Radial },
  { label: "Heatmap", value: "heatMap", Icon: Heatmap },
  {
    label: "Circular Progress",
    value: "circular-progress",
    Icon: CircularProgress,
  },
  { label: "Linear Progress", value: "linear-progress", Icon: LinearProgress },
  { label: "Sankey", value: "sankey", Icon: Sankey },
  { label: "Linear", value: "linear", Icon: Linear },
  { label: "HTML", value: "cards", Icon: Html },
  { label: "Map", value: "vectorMap", Icon: Map },
  {
    label: "Repeat",
    value: "repeat",
    Icon: Repeat,
  },
];

interface GraphOptionsButtonsProps {
  graphType: string;
  setGraphType: (value: string) => void;
}

const GraphOptionsButtons: React.FC<GraphOptionsButtonsProps> = ({
  graphType,
  setGraphType,
}) => {
  const theme = useTheme();

  return (
    <Box>
      <Grid
        container
        spacing={2}
        sx={{
          justifyContent: "start",
          alignItems: "center",
        }}
      >
        {ICONS.map(({ label, value, Icon }) => (
          <Grid
            sx={{ display: "flex" }}
            key={value}
            size={{ xs: 12, sm: 4, lg: 3, xl: 2 }}
          >
            <IconButton
              onClick={() => {
                setGraphType(value);
              }}
              sx={{
                padding: 0,
                borderRadius: 1,
                background:
                  graphType === value
                    ? theme.palette.action.selected
                    : "transparent",
                width: "100%",
              }}
            >
              <Box
                sx={{
                  border: 1,
                  borderColor: theme.palette.stroke,
                  borderRadius: 1,
                  padding: 1,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 1,
                  width: "100%",
                  height: 120,
                }}
              >
                <Typography
                  fontSize={"small"}
                  sx={{ textTransform: "uppercase" }}
                >
                  {label}
                </Typography>
                <Icon />
              </Box>
            </IconButton>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default GraphOptionsButtons;
